import { useNavigate } from "react-router-dom";
import "./SideBlogCard.scss";
import { baseUrl } from "../../../../utils/apiData";

const SideBlogCard = ({ image, subtitle, name, slug, k }) => {
  const navigate = useNavigate();

  return (
    <div
      className="side_blog_card wow fadeInUp"
      onClick={() => navigate(`/blog/${slug}`)}
      data-wow-delay={`${k * 0.1}s`}
    >
      <div className="img_wrap">
        <img src={`${baseUrl}/${image}`} alt="blog" />
      </div>
      <div className="text">
        <p className="t-12">{subtitle}</p>
        <h4>{name}</h4>
      </div>
    </div>
  );
};

export default SideBlogCard;
